import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { Form } from 'semantic-ui-react';

import { EXPORT_TOTALS_FORM_NAME } from 'Common/FormEnum';
import SelectSitesTable from 'Common/SelectSitesTable';
import { ExportTotalsFieldEnum } from 'Common/FieldEnum';
import { createFieldsValidator } from 'Common/FormHelper';
import { ExportTotalsEnum } from 'Common/Constants/Enumeration/ExportTotalsEnum';

import { Chartwells } from './components/Chartwells';

class ExportTotalsForm extends Component {
  renderSubPage = (exportType) => {
    switch (exportType) {
      case ExportTotalsEnum.Chartwells:
        return <Chartwells {...this.props} />;
      default:
        return null;
    }
  };

  render() {
    const { setSelectedSiteIds, exportType } = this.props;
    const { renderSubPage } = this;
    return (
      <Form>
        {renderSubPage(exportType)}
        <div className="site-picker-container">
          <SelectSitesTable
            onChange={setSelectedSiteIds}
            fetchAllSites={true}
          />
        </div>
      </Form>
    );
  }
}

const validator = createFieldsValidator([
  ExportTotalsFieldEnum.UnitNumber,
  ExportTotalsFieldEnum.BreakfastItemId,
  ExportTotalsFieldEnum.LunchItemId,
  ExportTotalsFieldEnum.FromDate,
  ExportTotalsFieldEnum.ToDate,
]);

const validate = (values) => {
  const errors = {};
  const validatorErrors = validator(values);
  return {
    ...errors,
    ...validatorErrors,
  };
};

ExportTotalsForm = reduxForm({
  form: EXPORT_TOTALS_FORM_NAME,
  validate,
})(ExportTotalsForm);

export { ExportTotalsForm };



// WEBPACK FOOTER //
// ./src/pages/exporttotals/ExportTotalsForm.js